import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';

import { PropertyBagService } from '../property-bag.service';

@Component({
    selector: 'cw-property-checkbox',
    templateUrl: './property-checkbox.component.html',
    standalone: false,
})
export class PropertyCheckboxComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;

    /** Input field with the required information for this field type */
    @Input() property!: Property;

    value = false;
    label = '';

    constructor(private propertyBagService: PropertyBagService) {}

    ngOnInit(): void {
        this.label = this.propertyBagService.getCorrectLabel(this.property);
        this.value = this.propertyBagService.getValueProperty(this.propertySet, this.property);
    }

    onChange(checked: boolean): void {
        this.property.value = checked;
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }
}
